/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_Picker_LegendInputs */

const en_map_picker_legend = /** @type {(inputs: Map_Picker_LegendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a map`)
};

const fr_map_picker_legend = /** @type {(inputs: Map_Picker_LegendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choix de la carte`)
};

const ms_sg2_map_picker_legend = /** @type {(inputs: Map_Picker_LegendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih peta`)
};

/**
* | output |
* | --- |
* | "Choose a map" |
*
* @param {Map_Picker_LegendInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const map_picker_legend = /** @type {((inputs?: Map_Picker_LegendInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_Picker_LegendInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_map_picker_legend(inputs)
	if (locale === "fr") return fr_map_picker_legend(inputs)
	return ms_sg2_map_picker_legend(inputs)
});